import { render } from "./Logo.vue?vue&type=template&id=4463c933&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=4463c933&lang=postcss&scoped=true"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4463c933"]])

export default __exports__